import React from "react";

interface VideoPlayerProps {
  src: string;
  type?: string;
  poster?: string;
  controls?: boolean;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  className?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  src,
  type = "video/mp4",
  poster,
  className = "video-container",
}) => {
  return (
    <div className={className}>
      <video
        className="video-player"
        poster={poster}
        controls={false}
        autoPlay={true}
        loop={true}
        muted={true}
        playsInline
      >
        <source src={src} type={type} />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;
